import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-input-clear",
  "use": "icon-s-input-clear-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-input-clear\"><path d=\"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0m4.02 6.736-3.909 3.91-3.91-3.91-.823.823 3.91 3.91-3.91 3.91.823.822 3.91-3.91 3.91 3.91.823-.823-3.91-3.91 3.91-3.909z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol